import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 22 22\" id=\"search\"><circle cx=\"8.728\" cy=\"8.727\" r=\"6.5\" stroke=\"currentColor\" stroke-width=\"3\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.218 12.351a1.952 1.952 0 012.75-.01l6.097 6.004a1.952 1.952 0 01-2.739 2.782l-6.098-6.005a1.952 1.952 0 01-.01-2.771z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol